import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Logindetail } from "../context/Logindetail.js";
import moment from "moment";
import toast from "react-hot-toast";
import { agency_edit_fun, comapny_edit_fun, getprofile_fun, update_fun, vendor_edit_fun } from "../api/Dashboardapi.js";
import { catalogue_fun, GenderApi } from "../api/Controllapi.js";
// import DatePicker from "react-datepicker";
import { CameraFill, ExclamationCircle, ShieldLock } from "react-bootstrap-icons";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { format, formatDate } from "date-fns";
import dayjs from "dayjs";
import { reference_fun } from "../api/Controllapi";
import { useNavigate } from "react-router-dom";
import instance from "../Config/Config.js";
import { FaEdit, FaTrashAlt, FaHome, FaTachometerAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { X } from "react-bootstrap-icons";

const Profile = ({ settings }) => {
  const today = dayjs().subtract(18, "years");
  const [file, setfile] = useState();
  const [imag, setimag] = useState();
  const [gender, setgender] = useState([]);
  const [update_data, setupdate_data] = useState([]);
  const [spinner, setspinner] = useState(false);
  const [spinner2, setspinner2] = useState(false);
  const [ProfileData, setProfileData] = useState([]);
  const [date, setdate] = useState();

  const [previewImage, setPreviewImage] = useState([]);
  const [showPreview, setShowPreview] = useState(true);
  const [refer_data, setrefer_data] = useState([]);
  const [showDeleteDesignModal, setShowDeleteDesignModal] = useState(false);
  const [designUrlToDelete, setDesignUrlToDelete] = useState("");

  const getrefer_api = () => {
    reference_fun(detail_info?.id || "")
      .then((res) => {
        setrefer_data(res?.data);
      })
      .catch((err) => {
      });
  };


  //added
  const getCatalogue = async () => {
    catalogue_fun()
      .then((res) => {
        setPreviewImage(res?.data);
      })
      .catch((err) => {
      })
  }

  const cancelCatelogueimage = (url) => {
    setDesignUrlToDelete(url);
    setShowDeleteDesignModal(true);
  };

  const handleConfirmDeleteDesign = async () => {
    if (!designUrlToDelete) return;

    try {
      const fileName = designUrlToDelete.split("/").pop();
      const responseApi = await instance.delete(`delete-catalogue/${fileName}`);
      if (responseApi?.data?.result) {
        setPreviewImage((prev) => prev.filter((url) => url !== designUrlToDelete));
        toast.success(responseApi?.data?.message || "Removed designs");
      } else {
        toast.error(responseApi?.data?.message || "Failed to remove design");
      }
    } catch (err) {
      console.error("Failed to delete design:", err);
      toast.error("Error deleting design");
    } finally {
      setShowDeleteDesignModal(false);
      setDesignUrlToDelete("");
    }
  };


  useEffect(() => {
    getrefer_api();
    // getCatalogue();
  }, []);

  // ....before...

  //   function handlechange(e) {

  //     if (
  //       e.target.files[0]?.size > 2 * 1024 * 1024 ||
  //       e.target.files[0]?.size <= 0
  //     ) {
  //       toast.error("File Size Max 2MB");
  //     } else {
  //       setfile(URL.createObjectURL(e.target.files[0]));
  //       setimag(e.target.files[0]);
  //       console.log("e.target.files[0]", e.target.files[0])
  //     }
  // }

  // ...................................... 2nd

  // function handlechange(e) {
  //   const file = e.target.files[0];
  //   if (!file) {
  //     toast.error("Upload Image");
  //   } else {
  //     setfile(URL.createObjectURL(e.target.files[0]));
  //     setimag(e.target.files[0]);
  //     console.log("e.target.files[0]", e.target.files[0]);
  //   }
  // }

  function handlechange(e) {
    const file = e.target.files[0];
    if (!file) return;

    setfile(URL.createObjectURL(e.target.files[0]));
    setimag(e.target.files[0]);
    // console.log("Selected file:", file);
  }
  const { detail_info, setdetail_info } = useContext(Logindetail);
  const [isReadOnly, setIsReadOnly] = useState(true);

  // console.log("detail_info", detail_info);

  //   console.log('detail_info?.avatardetail_info?.avatar',detail_info?.avatar);

  const initvalue = {
    name: `${detail_info?.name ? detail_info?.name : ""}`,
    // father_name: `${detail_info?.father_name ? detail_info?.father_name : ""}`,
    phone_number: `${detail_info?.phone_number ? detail_info?.phone_number : ""
      }`,
    email: `${detail_info?.email ? detail_info?.email : ""}`,
    date_of_birth: `${detail_info?.date_of_birth ? detail_info?.date_of_birth : ""
      }`,
    instagram: `${detail_info?.instagram ? detail_info?.instagram : ""}`,
    reference_id: `${detail_info?.reference_id ? detail_info?.reference_id : ""}`,
    gender: `${detail_info?.gender ? detail_info?.gender : "Male"}`,
    avatar: `${detail_info?.avatar ? detail_info?.avatar : ""}`,
  };

  const updateschema = Yup.object().shape({
    name: Yup.string()
      .required("Enter Full Name")
      .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
      .test(
        "not-only-spaces",
        "Name cannot be only spaces",
        (value) => value && value.trim().length > 0),

    // father_name: Yup.string()
    //   .required("Enter Mother Name")
    //   .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
    //   .test(
    //     "not-only-spaces",
    //     "Name cannot be only spaces",
    //     (value) => value && value.trim().length > 0),

    phone_number: Yup.string()
      .min(5, "Phone Number Minimum 5 digits")
      // .max(10, "Phone Number Maximum 10 digits")
      .required("Enter your Phone Number")
      .matches(/^[0-9]+$/, "Invalid  Phone Number"),

    email: Yup.string()
      .email("Invalid Email")
      .required("Enter Your Email")
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-z\-0-9]+\.)+[a-z]{2,}))$/,
        "Invalid Email"
      )
      .test("Invalid Email", (value) => {
        return value === value.toLowerCase();
      }),

    // "date_of_birth": Yup.date()
    //     .max(new Date(Date.now() - 567648000000), "You must be at least 18 years")
    //     .required("Enter DOB"),

    date_of_birth: Yup.string().required("Enter DOB"),

    gender: Yup.string(),
    instagram: Yup.string(),


    // avatar: Yup.mixed(),
  });

  const Formrik = useFormik({
    initialValues: initvalue,
    validationSchema: updateschema,
    onSubmit: async (value, { setErrors, setStatus, resetForm }) => {
      if (detail_info.role === 2) {
        if (!imag) {
          toast.error("Profile image is mandatory");
          return false;
        }
      }

      const DOB = moment(date).format("YYYY-MM-DD");

      const formdata = new FormData();
      formdata.append("name", value.name);
      // formdata.append("father_name", value.father_name);
      formdata.append("phone_number", value.phone_number);
      formdata.append("email", value.email);
      formdata.append("date_of_birth", DOB);
      formdata.append("gender", value.gender);
      formdata.append("instagram", value.instagram);

      formdata.append("avatar", imag);
      formdata.append("reference_id", refer_id)

      setspinner(true);
      // console.log("formdata", imag);

      await update_fun(formdata)
        .then((res) => {

          toast.success(res.message);
          setupdate_data(res?.user);
          handlegetprofile();
          setspinner(false);
          setIsReadOnly(true);
        })
        .catch((err) => {
          setspinner(false);
        });
    },
  });

  const genderapi = async () => {
    try {
      GenderApi((res) => {
        setgender(res?.data);
      }).catch((err) => {
      });
    } catch (err) {
    }
  };

  const handlegetprofile = () => {
    getprofile_fun()
      .then((res) => {
        localStorage.setItem("green_login", JSON.stringify(res?.data));
        setdetail_info(res?.data);
        setfile(res?.data?.avatar);
      })
      .catch((err) => {
      });
  };

  // useEffect(() => {
  //   genderapi();
  //   setfile(detail_info?.avatar ?? "");
  //   setimag(detail_info?.avatar ?? "");

  //   handlegetprofile();

  //   if(detail_info?.role == 1{
  //     getCatalogue()
  //   });
  // }, []);

  useEffect(() => {
    genderapi();
    setfile(detail_info?.avatar ?? "");
    setimag(detail_info?.avatar ?? "");

    handlegetprofile();

    if (detail_info?.company === 1) {
      getCatalogue();
    }
  }, []);


  const [inputValue, setInputValue] = useState("");
  const [refer_id, setRefer_id] = useState('')
  const [filteredData, setFilteredData] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  // Handle user input change
  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    // Filter data based on input value (only when input value is not empty)
    if (value) {
      const filtered = refer_data.filter((item) =>
        item?.code?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
      setIsDropdownVisible(filtered.length > 0);
    } else {
      // If the input is empty, hide the dropdown
      setFilteredData([]);
      setIsDropdownVisible(false);
    }
  };

  // Handle user selecting an item from the dropdown
  const handleSelect = (item) => {
    setInputValue(item.code);
    // console.log(item)
    setRefer_id(item.id)
    // console.log(refer_id,"skfsjdf")
    setIsDropdownVisible(false);
  };

  const navigate = useNavigate();

  const handleClick = (type) => {
    navigate("/FillForm", {
      state: { from: "profile", type: type },
    });
  };

  const [AddressList, setAddressList] = useState([]);

  const fetchAddress = async () => {
    try {
      const responseApi = await instance.get("address");
      // console.log("responseApi", responseApi?.data?.data);
      setAddressList(responseApi?.data?.data || []);
      // console.log(AddressList, "//./././.././.");
    } catch (err) {
      console.error("Failed to fetch addresses:", err);
    }
  };
  useEffect(() => {
    fetchAddress();
  }, []);

  // Handle deleting an address
  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await instance.get(`address/delete/${addressId}`);
      fetchAddress();
    } catch (error) {
      console.error("Error during address delete:", error);
    }
  };

  const handleEditClick = () => {
    setIsReadOnly(false); // or toggle it with: setIsReadOnly(prev => !prev)
  };

  const location = useLocation();
  const selectedRole = location?.state?.type || (window.location.pathname === "/user/companyprofile" ? (detail_info?.company_name ? (detail_info?.is_agency ? "Agency" : detail_info?.is_vendor ? "Vendor" : "Company") : "Agency") : "My Profile");

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingRoleData, setPendingRoleData] = useState(null);

  const handleConfirmEnrollment = () => {
    if (pendingRoleData) {
      handleActualSubmit(pendingRoleData);
    }
    setShowConfirmModal(false);
  };

  const initvalue2 = {
    GSTIN: `${detail_info?.gst ? detail_info?.gst : ""}`,
    Company_Name: `${detail_info?.company_name ? detail_info?.company_name : ""
      }`,
    PhoneNumber: `${detail_info?.c_phone_1 ? detail_info?.c_phone_1 : ""}`,
    Alternate_Phone_Number: `${detail_info?.c_phone_2 ? detail_info?.c_phone_2 : ""
      }`,
    country: `${detail_info?.c_country ? detail_info?.c_country : ""}`,
    state: `${detail_info?.c_state ? detail_info?.c_state : ""}`,
    requirement: `${detail_info?.c_address ? detail_info?.c_address : ""}`,
    city: `${detail_info?.c_city ? detail_info?.c_city : ""}`,
    postal_code: `${detail_info?.c_postal ? detail_info?.c_postal : ""}`,
    user_type: `${detail_info?.user_type ? detail_info?.user_type : ""}`,
  };

  const gstinRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const updateschema2 = Yup.object().shape({
    user_type: Yup.string().required("Please select a type"),
    Company_Name: Yup.string()
      .required("Company name is required")
      .matches(/^(?!\s*$).+$/, "Company name cannot be empty or only spaces"),

    GSTIN: Yup.string()
      .when('user_type', {
        is: "2",
        then: () => Yup.string().matches(gstinRegex, {
          message: "INVALID GSTIN",
          excludeEmptyString: true,
        }),
        otherwise: () => Yup.string()
          .required("GST REQUIRED")
          .matches(gstinRegex, "INVALID GSTIN"),
      }),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("Enter Your City"),
    requirement: Yup.string().required("Address is required"),
    postal_code: Yup.string().required("postal is required"),
    PhoneNumber: Yup.string()
      .min(5, "Phone Number Minimum 5 digits")
      .required("Enter Your Phone Number")
      .matches(/^[0-9]+$/, "Invalid  Phone Number"),
  });
  const handleActualSubmit = async (value) => {
    const data = {
      company: value.user_type == 0 ? "0" : "1",
      company_name: value.Company_Name,
      gst: value.GSTIN,
      c_phone_1: value.PhoneNumber,
      c_phone_2: value.Alternate_Phone_Number,
      c_address: value.requirement,
      c_country: value.country,
      c_state: value.state,
      c_city: value.city,
      c_postal: value.postal_code,
      user_type: value.user_type,
    };

    if (detail_info?.company_name) {
      setspinner(true);
      await comapny_edit_fun(data)
        .then((res) => {
          toast.success(res.message);
          setupdate_data(res?.user);
          handlegetprofile();
          setspinner(false);
          setIsReadOnly(true);
        })
        .catch((err) => {
          setspinner(false);
        });
    } else {
      try {
        const endpoint = "company_info";
        const responseApi = await instance.post(endpoint, data);
        toast.success(responseApi.data.message);
        handlegetprofile();
      } catch (err) {
        console.error("Failed to update profile:", err);
        toast.error("Failed to update profile");
      }
    }
  };

  const Formik2 = useFormik({
    initialValues: initvalue2,
    validationSchema: updateschema2,

    onSubmit: async (value) => {
      setPendingRoleData(value);
      setShowConfirmModal(true);
    },
    validateOnBlur: false,
    validateOnChange: false,
  });

  const handleCompanySubmitClick = async () => {
    const errors = await Formik2.validateForm();
    if (Object.keys(errors).length > 0) {
      const fieldMapping = {
        user_type: "Select Type",
        Company_Name: "Company Name",
        GSTIN: "GSTIN",
        PhoneNumber: "Phone Number",
        country: "Country",
        state: "State",
        city: "City",
        postal_code: "Postal Code",
        requirement: "Address"
      };

      // Define the order of fields from top to bottom
      const checkOrder = [
        "user_type",
        "Company_Name",
        "GSTIN",
        "PhoneNumber",
        "country",
        "state",
        "city",
        "postal_code",
        "requirement"
      ];

      // Find the first error in the defined order
      const firstErrorKey = checkOrder.find(key => errors[key]);

      if (firstErrorKey) {
        toast.error(errors[firstErrorKey] || `${fieldMapping[firstErrorKey] || firstErrorKey} is required`);
      }

      Formik2.setTouched(
        Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {})
      );
    } else {
      Formik2.handleSubmit();
    }
  };



  // useEffect(() => {
  //   AOS.init({
  //     duration: 1500,
  //   });
  // }, []);

  // .......................

  const router = useNavigate();

  // const [countryList, setCountryList] = useState([]);
  // const [selectedCountryId, setSelectedCountryId] = useState(
  //   detail_info?.c_country
  // );
  // const [stateList, setStateList] = useState([]);
  // const [selectedStateId, setSelectedStateId] = useState(detail_info?.c_state);
  // const [cityList, setCityList] = useState([]);

  // const fetchCountries = async () => {
  //   try {
  //     const responseApi = await instance.get("get_country");

  //     setCountryList(responseApi?.data?.data || []);
  //   } catch (err) {
  //     console.error("Failed to fetch countries:", err);
  //   }
  // };

  // useEffect(() => {
  //   const fetchStates = async () => {
  //     if (!selectedCountryId) return;
  //     try {
  //       const responseApi = await instance.get("get_state", {
  //         params: { country_id: selectedCountryId },
  //       });

  //       setStateList(responseApi?.data?.data || []);
  //     } catch (err) {
  //       console.error("Failed to fetch states:", err);
  //     }
  //   };

  //   fetchStates();
  // }, [selectedCountryId]);

  // useEffect(() => {
  //   const fetchCities = async () => {
  //     if (!selectedCountryId || !selectedStateId) return;

  //     try {
  //       const responseApi = await instance.get("get_city", {
  //         params: {
  //           country_id: selectedCountryId,
  //           state_id: selectedStateId,
  //         },
  //       });

  //       setCityList(responseApi?.data?.data || []);
  //     } catch (err) {
  //       console.error("Failed to fetch cities:", err);
  //     }
  //   };

  //   fetchCities();
  // }, [selectedCountryId, selectedStateId]); // ✅ Dependencies

  // useEffect(() => {
  //   fetchCountries();
  // }, []);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(detail_info?.c_country || "");
  const [stateList, setStateList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState(detail_info?.c_state || "");
  const [cityList, setCityList] = useState([]);

  // Fetch country list on load
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const responseApi = await instance.get("get_country");
        setCountryList(responseApi?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch countries:", err);
      }
    };
    fetchCountries();
  }, []);

  // Fetch states when selectedCountryId changes
  useEffect(() => {
    if (!selectedCountryId) {
      setStateList([]);
      return;
    }

    const fetchStates = async () => {
      try {
        const responseApi = await instance.get("get_state", {
          params: { country_id: selectedCountryId },
        });
        setStateList(responseApi?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch states:", err);
      }
    };

    fetchStates();
  }, [selectedCountryId]);

  // Fetch cities when both country and state are selected
  useEffect(() => {
    if (!selectedCountryId || !selectedStateId) {
      setCityList([]);
      return;
    }

    const fetchCities = async () => {
      try {
        const responseApi = await instance.get("get_city", {
          params: {
            country_id: selectedCountryId,
            state_id: selectedStateId,
          },
        });
        setCityList(responseApi?.data?.data || []);
      } catch (err) {
        console.error("Failed to fetch cities:", err);
      }
    };

    fetchCities();
  }, [selectedCountryId, selectedStateId]);


  const [adharfile, setAdharfile] = useState([]);

  const handleaadhar = (e) => {
    const data = Object.values(e.target.files);
    const currentTotal = (previewImage?.length || 0) + (adharfile?.length || 0);

    if (currentTotal + data.length > 3) {
      toast.error("Maximum 3 design documents allowed. Please remove a file to add a new one.");
      return;
    }

    for (let i = 0; i < data.length; i++) {
      const file = data[i];

      if (
        file?.type === "image/jpg" ||
        file?.type === "image/jpeg" ||
        file?.type === "image/png" ||
        file?.type === "application/pdf" ||
        file?.type === "application/vnd.ms-excel" ||
        file?.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file?.type === "application/msword" ||
        file?.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        setAdharfile((prev) => [...prev, file]);
      } else {
        toast.error("Check image format");
      }
    }
  };

  const cancelimage = (value) => {
    setAdharfile((p) => p?.filter((r) => r != value));
  };

  const updateschema3 = Yup.object().shape({
    documents: Yup.mixed(),
  });

  const [initValue3, setinitValue3] = useState({
    documents: `${detail_info?.documents ? detail_info?.documents : ""}`,
  });


  //for handling refer
  useEffect(() => {
    if (detail_info) {
      const apiValue =
        detail_info.ref_name || detail_info.ref_code
          ? `${detail_info.ref_name ?? ""}${detail_info.ref_name && detail_info.ref_code ? " - " : ""
          }${detail_info.ref_code ?? ""}`
          : "";
      setInputValue(apiValue);
    }
  }, [detail_info]);

  const Formrik3 = useFormik({
    initialValues: initValue3,
    validationSchema: updateschema3,
    onSubmit: async (value, { setErrors, setStatus, resetForm }) => {
      const formdata = new FormData();
      adharfile?.map((data, i) => {
        formdata.append(`documents[${i}]`, data);
      });
      // console.log("formdata", formdata);

      try {
        setspinner2(true);
        const responseApi = await instance.post("catalogue", formdata);
        setAdharfile([]);
        getCatalogue();
        setspinner2(false);
        toast.success("Designs Successfully Updated")
      } catch (err) {
        console.error("Failed to fetch cities:", err);
      }
    },
  });

  return (
    <>
      {selectedRole === "Company" || selectedRole === "Agency" || selectedRole === "Vendor" ? (
        <HeadingBanner title={selectedRole === "Agency" ? "Agency" : selectedRole === "Vendor" ? "Vendor" : "Company"} />
      ) : (
        <HeadingBanner title={"My Profile"} />
      )}

      <section>
        <div className="container">
          <div className="profile_layout">
            <div className="row">
              <div className="col-xl-3 col-lg-4">
                <Dashboard setting_data={settings} />
              </div>

              <div className="col-xl-9 col-lg-8">
                {window.location.pathname === "/user/companyprofile" && detail_info?.role === 1 ? (
                  <div className="access-denied-container">
                    <div className="access-denied-content">
                      <div className="access-denied-icon">
                        <ShieldLock />
                      </div>
                      <h2 className="access-denied-title">Access Denied</h2>
                      <p className="access-denied-text">
                        You are not authorized to view the Company Profile. This section is restricted for specific roles.
                        If you believe this is an error, please contact your administrator.
                      </p>
                      <div className="access-denied-actions">
                        <button className="access-denied-btn access-denied-btn-primary" onClick={() => navigate("/")}>
                          <FaHome /> Back to Home
                        </button>
                        <button className="access-denied-btn access-denied-btn-secondary" onClick={() => navigate("/user/dashboard")}>
                          <FaTachometerAlt /> Go to Dashboard
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {(selectedRole === "Company" || selectedRole === "Agency" || selectedRole === "Vendor") && (
                      <div className="myprofile-content">
                        <div className="bd-heads pb-3 d-flex justify-content-between align-items-center">
                          <h4>Company Profile</h4>
                        </div>
                        <div className="bd-form border position-relative">
                          {detail_info?.user_type_request == 1 && (
                            <div
                              className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center"
                              style={{
                                top: 0,
                                left: 0,
                                zIndex: 10,
                                backgroundColor: "rgba(255, 255, 255, 0.6)",
                                borderRadius: "10px",
                              }}
                            >
                              <div className="text-center p-4 bg-white shadow rounded border">
                                <h5 className="mb-0 text-primary">
                                  <i className="fa fa-clock-o me-2"></i>
                                  Waiting for admin approval
                                </h5>
                              </div>
                            </div>
                          )}

                          {detail_info?.user_type_request == 3 && (
                            <div className="alert alert-danger m-4 mb-0">
                              <strong><i className="fa fa-exclamation-circle me-2"></i>Registration Rejected:</strong>
                              <p className="mb-0 mt-2">{detail_info?.remarks || "No remarks provided."}</p>
                            </div>
                          )}

                          <form
                            onSubmit={Formik2.handleSubmit}
                            style={{
                              filter: detail_info?.user_type_request == 1 ? "blur(4px)" : "none",
                              pointerEvents: detail_info?.user_type_request == 1 ? "none" : "auto",
                            }}
                          >
                            <div className="row p-4">
                              <div className="form-group col-md-12 col-sm-12 col-12 login-text mb-3">
                                <label>Select Type</label>
                                <div className="user-type-group">
                                  {[
                                    { value: "1", label: "Manufacturer", icon: "/assets/iocns/manufacture.png" },
                                    { value: "2", label: "Agency", icon: "/assets/iocns/agency.png" },
                                    { value: "3", label: "Dealers", icon: "/assets/iocns/dealer.png" }
                                  ].filter(opt => (detail_info?.user_type == 0 || detail_info?.user_type == "" || detail_info?.user_type == null) ? true : detail_info?.user_type == opt.value).map((opt) => (
                                    <div
                                      key={opt.value}
                                      className={`user-type-card ${Formik2.values.user_type == opt.value ? "selected" : ""}`}
                                      style={{
                                        cursor: (detail_info?.user_type != 0 && detail_info?.user_type != "" && detail_info?.user_type != null) || detail_info?.user_type_request == 1 ? "default" : "pointer"
                                      }}
                                      onClick={() => {
                                        if ((detail_info?.user_type == 0 || detail_info?.user_type == "" || detail_info?.user_type == null) && detail_info?.user_type_request != 1) {
                                          Formik2.setFieldValue("user_type", opt.value);
                                        }
                                      }}
                                    >
                                      <div className="user-type-icon-circle">
                                        <img src={opt.icon} alt={opt.label} />
                                      </div>
                                      <span className="user-type-label">{opt.label}</span>
                                      <div className="user-type-radio-check"></div>
                                    </div>
                                  ))}
                                </div>
                                {Formik2.touched.user_type && Formik2.errors.user_type ? (
                                  <p className="text-danger mt-2">{Formik2.errors.user_type}</p>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6 col-sm-6 col-6 login-text form-group-fixed">
                                <label>
                                  Company Name<span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputfirtname"
                                  placeholder="Company Name"
                                  {...Formik2.getFieldProps("Company_Name")}
                                />
                                {Formik2.touched.Company_Name &&
                                  Formik2.errors.Company_Name ? (
                                  <p className="text-danger error-msg-static d-none">
                                    {Formik2.errors.Company_Name}
                                  </p>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6 col-sm-6  col-6 login-text form-group-fixed">
                                <label>
                                  GSTIN  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputPhone"
                                  placeholder="GSTIN"
                                  {...Formik2.getFieldProps("GSTIN")}
                                />
                                {Formik2.touched.GSTIN && Formik2.errors.GSTIN ? (
                                  <p className="text-danger error-msg-static d-none">
                                    {Formik2.errors.GSTIN}
                                  </p>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6 col-sm-6  col-6 login-text form-group-fixed">
                                <label>
                                  Phone Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="inputPhone"
                                  placeholder="Phone Number"
                                  {...Formik2.getFieldProps("PhoneNumber")}
                                />
                                {Formik2.touched.PhoneNumber &&
                                  Formik2.errors.PhoneNumber ? (
                                  <p className="text-danger error-msg-static d-none">
                                    {Formik2.errors.PhoneNumber}
                                  </p>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6 col-sm-6  col-6 login-text">
                                <label>
                                  Alternate Phone Number{" "}
                                  <span className="text-danger"></span>
                                </label>
                                <input
                                  type="number"
                                  className="form-control"
                                  id="inputAlternatePhoneNumber"
                                  placeholder="Alternate Phone Number"
                                  {...Formik2.getFieldProps(
                                    "Alternate_Phone_Number"
                                  )}
                                />
                              </div>
                              <div className="form-group col-md-6 col-sm-6 col-6 login-text form-group-fixed">
                                <label>
                                  Country <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control forminputpad"
                                  id="inputCountry"
                                  value={Formik2.values.country}
                                  onChange={(e) => {
                                    const selectedCountryId = e.target.value;
                                    Formik2.setFieldValue("country", selectedCountryId);
                                    Formik2.setFieldValue("state", ""); // reset state
                                    Formik2.setFieldValue("city", ""); // reset city
                                    setSelectedCountryId(selectedCountryId);
                                    setSelectedStateId(""); // reset for dependent
                                  }}
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {countryList.map((country) => (
                                    <option key={country.id} value={country.id}>
                                      {country.name}
                                    </option>
                                  ))}
                                </select>
                                {Formik2.touched.country && Formik2.errors.country && (
                                  <p className="text-danger error-msg-static d-none">{Formik2.errors.country}</p>
                                )}
                              </div>

                              <div className="form-group col-md-6 col-sm-6 col-6 login-text form-group-fixed">
                                <label>
                                  State <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control forminputpad"
                                  id="inputState"
                                  value={Formik2.values.state}
                                  onChange={(e) => {
                                    const selectedStateId = e.target.value;
                                    Formik2.setFieldValue("state", selectedStateId);
                                    Formik2.setFieldValue("city", ""); // reset city
                                    setSelectedStateId(selectedStateId);
                                  }}
                                // disabled={!stateList.length}
                                >
                                  <option value="" disabled>
                                    {stateList.length > 0 ? "Select" : "Select the Country first"}
                                    {/* Select State */}
                                  </option>
                                  {stateList.map((state) => (
                                    <option key={state.id} value={state.id}>
                                      {state.state}
                                    </option>
                                  ))}
                                </select>
                                {Formik2.touched.state && Formik2.errors.state && (
                                  <p className="text-danger error-msg-static d-none">{Formik2.errors.state}</p>
                                )}
                              </div>

                              <div className="form-group col-md-6 col-sm-6 col-6 login-text form-group-fixed">
                                <label>
                                  City <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-control forminputpad"
                                  id="inputCity"
                                  value={Formik2.values.city}
                                  onChange={(e) => {
                                    const selectedCityId = e.target.value;
                                    Formik2.setFieldValue("city", selectedCityId);
                                  }}
                                // disabled={!cityList.length}
                                >
                                  <option value="" disabled>
                                    {cityList.length > 0 ? "Select" : "Select the State first"}
                                    {/* Select City */}
                                  </option>
                                  {cityList.map((city) => (
                                    <option key={city.id} value={city.id}>
                                      {city.city}
                                    </option>
                                  ))}
                                </select>
                                {Formik2.touched.city && Formik2.errors.city && (
                                  <p className="text-danger error-msg-static d-none">{Formik2.errors.city}</p>
                                )}
                              </div>

                              {/* 
                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>
                              Country <span className="text-danger">*</span>
                            </label>

                            <select
                              className="form-control forminputpad"
                              id="inputCountry"
                              value={Formik2.values.country}
                              onChange={(e) => {
                                const selectedCountryId = e.target.value;
                                Formik2.setFieldValue(
                                  "country",
                                  selectedCountryId
                                );
                                setSelectedCountryId(selectedCountryId);
                              }}
                            >
                              <option value="" disabled>
                                Select Country
                              </option>
                              {countryList.map((country) => (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </select>

                            {Formik2.touched.country &&
                              Formik2.errors.country && (
                                <p className="text-danger">
                                  {Formik2.errors.country}
                                </p>
                              )}
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>
                              State <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control forminputpad"
                              id="inputState"
                              value={Formik2.values.state}
                              onChange={(e) => {
                                const selectedStateId = e.target.value;
                                Formik2.setFieldValue("state", selectedStateId); // store state.id

                                setSelectedStateId(selectedStateId); // for fetching city
                              }}
                            >
                              <option value="" disabled>
                                {stateList.length > 0 ? "Select State" : "no states"}
                              </option>
                              {stateList.map((state) => (
                                <option key={state.id} value={state.id}>
                                  {state.state}
                                </option>
                              ))}
                            </select>

                            {Formik2.touched.country &&
                              Formik2.errors.state && (
                                <p className="text-danger">
                                  {Formik2.errors.state}
                                </p>
                              )}
                          </div>

                          <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                            <label>
                              City <span className="text-danger">*</span>
                            </label>

                            {/* <select
                    className="form-control"
                    id="inputState"
                    value={Formik.values.city}
                    onChange={(e) => {
                      const selectedStateName = e.target.value;
                      Formik.setFieldValue("city", selectedStateName);
                    }}
                  >
                    <option value="" disabled>
                      Select City
                    </option>
                    {cityList.map((state) => (
                      <option key={state.id} value={state.city}>
                        {state.city}
                      </option>
                    ))}
                  </select> */}

                              {/* <select
                            className="form-control forminputpad"
                            id="inputCity"
                            value={Formik2.values.city}
                            onChange={(e) => {
                              const selectedCityId = e.target.value;
                              Formik2.setFieldValue("city", selectedCityId);
                            }}
                          >
                            <option value="" disabled>
                              Select City
                            </option>
                            {cityList.map((city) => (
                              <option key={city.id} value={city.id}>
                                {city.city}
                              </option>
                            ))}
                          </select>

                          {Formik2.touched.country && Formik2.errors.city && (
                            <p className="text-danger">
                              {Formik2.errors.city}
                            </p>
                          )} */}
                              {/* </div> */}

                              <div className="form-group col-md-6 col-sm-6 col-6 login-text form-group-fixed">
                                <label>
                                  Postal Code <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputfirtname"
                                  placeholder="Postal Code"
                                  {...Formik2.getFieldProps("postal_code")}
                                />
                                {Formik2.touched.postal_code &&
                                  Formik2.errors.postal_code ? (
                                  <p className="text-danger error-msg-static d-none">
                                    {Formik2.errors.postal_code}
                                  </p>
                                ) : null}
                              </div>

                              <div className="form-group submit login-text form-group-fixed">
                                <label>
                                  Office Address{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  className="form-control"
                                  id="exampleFormControlTextarea1"
                                  rows={5}
                                  placeholder="Address"
                                  {...Formik2.getFieldProps("requirement")}
                                ></textarea>
                                {Formik2.touched.requirement &&
                                  Formik2.errors.requirement ? (
                                  <p className="text-danger error-msg-static d-none">
                                    {Formik2.errors.requirement}
                                  </p>
                                ) : null}
                              </div>
                            </div>

                            {detail_info?.company_name ? (
                              <div className="update-profile  mx-3">
                                <button
                                  className="text-white"
                                  type="button"
                                  onClick={handleCompanySubmitClick}
                                >
                                  {spinner ? (
                                    <span className="spinner-border spinner-border-sm" role="status"></span>
                                  ) : (
                                    "Save"
                                  )}
                                </button>
                              </div>
                            ) : (
                              <div className="update-profile  mx-3">
                                <button
                                  className="text-white"
                                  type="button"
                                  onClick={handleCompanySubmitClick}
                                >
                                  {spinner ? (
                                    <span className="spinner-border spinner-border-sm" role="status"></span>
                                  ) : (
                                    "Add"
                                  )}
                                </button>
                              </div>
                            )}

                            {/* {isReadOnly === false && (
                        <div className="update-profile  mx-3">
                          <button className="text-white" type="submit">
                            {spinner ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                              ></span>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      )}

                      {isReadOnly === true && (
                        <div className="update-profile mx-3">
                          <button
                            type="button"
                            className="text-white"
                            onClick={handleEditClick}
                          >
                            {spinner ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                              ></span>
                            ) : (
                              "Edit"
                            )}
                          </button>
                        </div>
                      )} */}
                          </form>
                        </div>
                      </div>
                    )}

                    {selectedRole !== "Company" && selectedRole !== "Agency" && selectedRole !== "Vendor" && (
                      <div className="myprofile-content">
                        <div className="bd-heads pb-3">
                          <h4>My Profile</h4>
                        </div>
                        <div className="bd-form border">
                          <form onSubmit={Formrik.handleSubmit}>
                            <div className="profice-pic text-center position-relative">
                              <img
                                src={file ? file : "/assets/images/user.jfif"}
                                id="uploadimg"
                                className="img-fluid"
                                alt="profile_img"
                              />
                              <input
                                type="file"
                                id="my_file"
                                className="d-none"
                                accept="image/*"
                                onChange={handlechange}
                              // readOnly={isReadOnly}s
                              />

                              {isReadOnly === true && (
                                <div
                                  className=" profile-came position-absolute"
                                  onClick={() => {
                                    document.getElementById("my_file").click();
                                  }}
                                >
                                  <CameraFill />
                                </div>
                              )}

                              {isReadOnly === false && (
                                <div
                                  className=" profile-came position-absolute"
                                  onClick={() => {
                                    document.getElementById("my_file").click();
                                  }}
                                >
                                  <CameraFill />
                                </div>
                              )}

                              {Formrik.touched.avatar && Formrik.errors.avatar ? (
                                <p className="text-danger">
                                  {Formrik.errors.avatar}
                                </p>
                              ) : null}
                            </div>
                            <div className="row p-4">
                              <div className="form-group col-md-6 col-sm-6 col-6  login-text">
                                <label> Full Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputname"
                                  placeholder=" Name"
                                  {...Formrik.getFieldProps("name")}
                                // readOnly={isReadOnly}
                                />
                                {Formrik.touched.name && Formrik.errors.name ? (
                                  <span className="text-danger">
                                    {Formrik.errors.name}
                                  </span>
                                ) : null}
                              </div>
                              {/* <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                            <label>Mother Name</label>
                            <input
                              type="text"
                              className="form-control"
                              id="inputfathername"
                              placeholder="Mother Name"
                              // readOnly={isReadOnly}
                              {...Formrik.getFieldProps("father_name")}
                            />
                            {Formrik.touched.father_name &&
                              Formrik.errors.father_name ? (
                              <span className="text-danger">
                                {Formrik.errors.father_name}
                              </span>
                            ) : null}
                          </div> */}

                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Email</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputemail1"
                                  placeholder="Email"
                                  // readOnly={isReadOnly}
                                  {...Formrik.getFieldProps("email")}
                                />
                                {Formrik.touched.email && Formrik.errors.email ? (
                                  <span className="text-danger">
                                    {Formrik.errors.email}
                                  </span>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Phone</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled
                                  id="inputPhone"
                                  placeholder="Phone"
                                  {...Formrik.getFieldProps("phone_number")}
                                // readOnly={isReadOnly}
                                />
                                {Formrik.touched.phone_number &&
                                  Formrik.errors.phone_number ? (
                                  <span className="text-danger">
                                    {Formrik.errors.phone_number}
                                  </span>
                                ) : null}
                              </div>
                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Date of Birth</label>
                                {/* <input type="date" className="form-control" id="inputemail2" placeholder="D-O-B" {...Formrik.getFieldProps("date_of_birth")} /> */}
                                <div className="react-date">
                                  {/* <DatePicker
                                                            selected={date}
                                                            dateFormat="dd/MM/yyyy"
                                                            minDate={new Date(moment().subtract(100, "years"))}
                                                            maxDate={new Date(moment().subtract(18, "years"))}
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            placeholderText="DD-MM-YYYY"
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            onChange={(date) => { setdate(date); Formrik.setFieldValue('date_of_birth', moment(date).format('YYYY-MM-DD')) }}

                                                        /> */}
                                  {/*
                            {isReadOnly === true && (
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DemoContainer
                                  components={["DatePicker", "DatePicker"]}
                                >
                                  <DatePicker
                                    maxDate={today}
                                    format="DD-MM-YYYY"
                                    onChange={(newValue) => {
                                      setdate(
                                        dayjs(newValue).format("YYYY-MM-DD")
                                      );
                                    }}
                                    defaultValue={
                                      detail_info?.date_of_birth
                                        ? dayjs(detail_info?.date_of_birth)
                                        : ""
                                    }
                                    sx={{
                                      backgroundColor: "#b7b2b221",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                      "&.Mui-focused": {
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border: "none",
                                        },
                                      },
                                    }}
                                    slotProps={{
                                      field: {
                                        readOnly: true,
                                      },
                                    }}
                                  />
                                </DemoContainer>
                              </LocalizationProvider>
                            )} */}
                                  {/*
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DatePicker"]}>
                                <DatePicker
                                  maxDate={today}
                                  inputFormat="DD-MM-YYYY"
                                  onChange={(newValue) => {
                                    setdate(
                                      dayjs(newValue).format("YYYY-MM-DD")
                                    );
                                  }}
                                  defaultValue={
                                    detail_info?.date_of_birth
                                      ? dayjs(detail_info.date_of_birth)
                                      : null
                                  }
                                  sx={{
                                    backgroundColor: "#b7b2b221",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: "none",
                                    },
                                    "&.Mui-focused": {
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    },
                                  }}
                                  // Remove readOnly to allow typing
                                />
                              </DemoContainer>
                            </LocalizationProvider> */}

                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                      maxDate={today}
                                      format="DD-MM-YYYY"
                                      openTo="year"
                                      views={['year', 'month', 'day']}
                                      onChange={(newValue) => {
                                        setdate(
                                          dayjs(newValue).format("YYYY-MM-DD")
                                        );
                                        Formrik.setFieldValue('date_of_birth', newValue ? dayjs(newValue).format('YYYY-MM-DD') : '');
                                      }}
                                      value={
                                        Formrik.values.date_of_birth
                                          ? dayjs(Formrik.values.date_of_birth)
                                          : null
                                      }
                                      sx={{
                                        width: '100%',
                                        backgroundColor: "#b7b2b221",
                                        "& .MuiOutlinedInput-root": {
                                          height: '45px',
                                          borderRadius: '5px',
                                        },
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          border: "none",
                                        },
                                        "&.Mui-focused": {
                                          "& .MuiOutlinedInput-notchedOutline": {
                                            border: "none",
                                          },
                                        },
                                      }}
                                      slotProps={{
                                        textField: {
                                          fullWidth: true,
                                          placeholder: "DD-MM-YYYY",
                                          error: Formrik.touched.date_of_birth && Boolean(Formrik.errors.date_of_birth),
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </div>
                                {Formrik.touched.date_of_birth &&
                                  Formrik.errors.date_of_birth ? (
                                  <span className="text-danger">
                                    {Formrik.errors.date_of_birth}
                                  </span>
                                ) : null}
                              </div>

                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Instagram (Use Link)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="inputInstagram"
                                  placeholder="Instagram"
                                  // readOnly={isReadOnly}
                                  {...Formrik.getFieldProps("instagram")}
                                />
                                {Formrik.touched.instagram &&
                                  Formrik.errors.instagram ? (
                                  <span className="text-danger">
                                    {Formrik.errors.instagram}
                                  </span>
                                ) : null}
                              </div>



                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Gender</label>
                                <select
                                  className="form-select"
                                  id="inputGroupSelect01"
                                  // disabled={isReadOnly}
                                  {...Formrik.getFieldProps("gender")}
                                >
                                  {/* {
                                gender ? gender.map((r,i) => {
                                   return (
                                       <option value={r.id} key={i}>{r.name}</option>
                                       )
                                                     }) : ""
                                                        } */}
                                  <option value="" selected disabled>
                                    Select
                                  </option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                </select>
                                {Formrik.touched.gender && Formrik.errors.gender ? (
                                  <span className="text-danger">
                                    {Formrik.errors.gender}
                                  </span>
                                ) : null}
                              </div>

                              {/* {!Formrik.values.reference_id && ( */}
                              <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                                <label>Referral ID</label>

                                <div className="autocomplete-container w-100">
                                  {/* <input
                                type="text"
                                // value={
                                //   inputValue ||
                                //   (
                                //     detail_info?.ref_name || detail_info?.ref_code
                                //       ? `${detail_info?.ref_name ?? ""}${detail_info?.ref_name && detail_info?.ref_code ? " - " : ""}${detail_info?.ref_code ?? ""}`
                                //       : ""
                                //   )
                                // }

                                value={
                                  inputValue !== undefined
                                    ? inputValue
                                    : (
                                      detail_info?.ref_name || detail_info?.ref_code
                                        ? `${detail_info?.ref_name ?? ""}${detail_info?.ref_name && detail_info?.ref_code ? " - " : ""}${detail_info?.ref_code ?? ""}`
                                        : ""
                                    )
                                }


                                // value={inputValue || detail_info?.ref_name-detail_info?.ref_code || ""}
                                onChange={handleChange}
                                disabled={detail_info?.reference_id !== 1}
                                onFocus={() =>
                                  setIsDropdownVisible(filteredData.length > 0 && inputValue !== "")
                                }
                                placeholder="Type to filter..."
                                className="autocomplete-input form-control"
                              /> */}
                                  <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleChange}
                                    disabled={detail_info?.reference_id !== 1}
                                    onFocus={() =>
                                      setIsDropdownVisible(filteredData.length > 0 && inputValue !== "")
                                    }
                                    placeholder="Type to filter..."
                                    className="autocomplete-input form-control"
                                  />

                                  {/* <input
                                type="text"
                                // value={
                                //   inputValue ||
                                //   (
                                //     detail_info?.ref_name || detail_info?.ref_code
                                //       ? `${detail_info?.ref_name ?? ""}${detail_info?.ref_name && detail_info?.ref_code ? " - " : ""}${detail_info?.ref_code ?? ""}`
                                //       : ""
                                //   )
                                // }
                                value={
  inputValue !== null && inputValue !== undefined
    ? inputValue
    : (
        detail_info?.ref_name || detail_info?.ref_code
          ? `${detail_info?.ref_name ?? ""}${detail_info?.ref_name && detail_info?.ref_code ? " - " : ""}${detail_info?.ref_code ?? ""}`
          : ""
      )
}

                                onChange={handleChange}
                                disabled={Number(detail_info?.reference_id) !== 1}
                                onFocus={() =>
                                  setIsDropdownVisible(filteredData.length > 0 && inputValue !== "")
                                }
                                placeholder="Type to filter..."
                                className="autocomplete-input form-control"
                              /> */}





                                  {isDropdownVisible && (
                                    <div className="autocomplete-dropdown">
                                      {/* {filteredData
                                    .filter(
                                      (item) => String(item.code) !== detail_info.code

                                    )
                                    .map((item) => (
                                      <div
                                        key={item.id}
                                        onClick={() => handleSelect(item)}
                                        className="autocomplete-item"
                                      >
                                        {item.code}
                                      </div>
                                    ))} */}


                                      {filteredData.map((item) => (
                                        <div
                                          key={item.id}
                                          onClick={() => handleSelect(item)}
                                          className="autocomplete-item"
                                        >
                                          {item.code}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {Formrik.touched.reference_id && Formrik.errors.reference_id ? (
                                  <span className="text-danger">{Formrik.errors.reference_id}</span>
                                ) : null}
                              </div>
                              {/* )} */}

                              {/* {
                            (true) ? (
                              <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                                <label>Referral ID</label>

                                <div className="autocomplete-container w-100">
                                  <input
                                    type="text"
                                    value={inputValue}
                                    onChange={handleChange}
                                    onFocus={() => setIsDropdownVisible(filteredData.length > 0 && inputValue !== '')}
                                    placeholder="Type to filter..."
                                    className="autocomplete-input form-control"
                                  />
                                  {isDropdownVisible && (
                                    <div className="autocomplete-dropdown">
                                      {filteredData.map((item) => (
                                        <div
                                          key={item.id}
                                          onClick={() => handleSelect(item)}
                                          className="autocomplete-item"
                                        >
                                          {item.code}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                {
                                  Formrik.touched.reference_id && Formrik.errors.reference_id ? (<span className="text-danger">{Formrik.errors.reference_id}</span>) : null
                                }

                              </div>
                            ) : (
                              <div>
                                <p>Reference Id : asdsadds</p>
                              </div>
                            )
                          } */}
                            </div>

                            <div className="update-profile  mx-3">
                              <button className="text-white" type="submit">
                                {spinner ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  ></span>
                                ) : (
                                  "Save"
                                )}
                              </button>
                            </div>



                            {/* {isReadOnly === true && (
                          <div className="update-profile mx-3">
                            <button
                              type="button"
                              className="text-white"
                              onClick={handleEditClick}
                            >
                              {spinner ? (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                ></span>
                              ) : (
                                "Edit"
                              )}
                            </button>
                          </div>
                        )} */}
                          </form>
                        </div>
                      </div>
                    )}

                    {(selectedRole === "Company" || selectedRole === "Agency" || selectedRole === "Vendor") && detail_info?.company === 1 ? (
                      <div className="myprofile-content mt-3">
                        <div className="bd-form border">
                          <div className="profice-pic position-relative">
                            <div className="bd-heads  ms-3 d-flex justify-content-between me-3 ">
                              <h4> Designs</h4>
                            </div>
                          </div>
                          <div className="row pt-3 pe-3 ps-3 pb-3">
                            <div className="col-12">
                              <div className="p-3 bg-light-primary border border-primary rounded d-flex justify-content-between align-items-center">
                                <div>
                                  <h5 className="fw-bold text-dark mb-1"><i className="fa fa-palette text-primary me-2"></i>Multi-Product Design Interface</h5>
                                  <p className="text-muted fs-7 mb-0">Upload unlimited product designs with custom weights, quantities, descriptions, and track admin approval status.</p>
                                </div>
                                <Link to="/user/manufacturer-designs" className="btn btn-primary btn-sm">
                                  Open Multi-Design Portal <i className="fa fa-arrow-right ms-1"></i>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}


                          {/* {AddressList && AddressList?.length > 0 && (
                        <div className="product-grid mb-3 mt-3">
                          {AddressList?.map((item) => (
                            <div key={item?.id} className="product-card">
                              <div className="product-info ">
                                <div className="d-flex justify-content-between">
                                  <h6 className="text-start mb-2 colhome ">
                                    <FaHome
                                      style={{
                                        fontSize: "18px",
                                        color: "#650020",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <b className="ms-3">Company Details</b>
                                  </h6>

                                  <div className="d-flex">
                                    <FaTrashAlt
                                      className=""
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "#650020",
                                      }} // Set the same fixed size for Delete icon
                                      onClick={() =>
                                        handleDeleteAddress(item.id)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                               <div className="product-info ">
                              <p className="product-name text-start padajsut">
                                {item?.address_line_1}
                                {item?.address_line_2},
                              </p>
                                <p className="product-name text-start padajsut2">
                             <b> {item?.states?.state}, {item?.countrys?.name}{" "}
                                {item?.postal_code}</b>

                              </p>
                            </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* { detail_info && (
                        <div className="product-grid mb-3 mt-3">
                            <div  className="product-card">
                              <div className="product-info ">
                                <div className="d-flex justify-content-between">
                                  <h6 className="text-start mb-2 colhome ">
                                    <FaHome
                                      style={{
                                        fontSize: "18px",
                                        color: "#650020",
                                        marginRight: "8px",
                                      }}
                                    />
                                    <b className="ms-3">Company Details</b>
                                  </h6>

                                  <div className="d-flex">
                                    <FaTrashAlt
                                      className=""
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        marginLeft: "10px",
                                        marginRight: "10px",
                                        color: "#650020",
                                      }} // Set the same fixed size for Delete icon
                                      onClick={() =>
                                        handleDeleteAddress(detail_info.id)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                               <div className="product-info ">
                              <p className="product-name text-start padajsut">
                                {detail_info?.address_line_1}
                                {detail_info?.address_line_2},
                              </p>
                                <p className="product-name text-start padajsut2">
                             <b> {detail_info?.states?.state}, {detail_info?.countrys?.name}{" "}
                                {detail_info?.postal_code}</b>

                              </p>
                            </div>
                            </div>
                        </div>
                      )} */}
                    ) : selectedRole !== "Company" && selectedRole !== "Agency" && selectedRole !== "Vendor" ? (

                      <div className="myprofile-content mt-3">
                        <div className="bd-form border">
                          <form onSubmit={Formrik3.handleSubmit}>
                            <div className="profice-pic position-relative">
                              <div className="bd-heads  ms-3 d-flex justify-content-between me-3 ">
                                <h4>Shipping Address</h4>
                                <div className="form-group d-flex justify-content-end">
                                  <div
                                    onClick={() => handleClick("user")}
                                    className="designprofile"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <h6>
                                      <b>
                                        <i className="fa fa-plus-circle color"></i>{" "}
                                      </b>{" "}
                                      <b className="fontsmall ">Add Address</b>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>

                          {AddressList && AddressList?.length > 0 && (
                            <div className="product-grid mb-3 mt-3">
                              {AddressList?.map((item) => (
                                <div key={item?.id} className="product-card">
                                  <div className="product-info ">
                                    <div className="d-flex justify-content-between">
                                      <h6 className="text-start mb-2 colhome ">
                                        <FaHome
                                          style={{
                                            fontSize: "18px",
                                            color: "#650020",
                                            marginRight: "8px",
                                          }}
                                        />
                                        {/* <b className="ms-3">none</b> */}
                                        <b className="ms-3">
                                          {{
                                            1: "Home",
                                            2: "Work",
                                            3: "Other",
                                          }[item?.type] || "Unknown"}
                                        </b>
                                      </h6>

                                      <div className="d-flex">
                                        <FaTrashAlt
                                          className=""
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                            marginLeft: "10px",
                                            marginRight: "10px",
                                            color: "#650020",
                                          }} // Set the same fixed size for Delete icon
                                          onClick={() =>
                                            handleDeleteAddress(item.id)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="product-info ">
                                    <p className="product-name text-start padajsut">
                                      {item?.address_line_1}
                                      {item?.address_line_2},
                                    </p>
                                    <p className="product-name text-start padajsut2">
                                      <b>
                                        {" "}
                                        {item?.states?.state},{" "}
                                        {item?.countrys?.name} {item?.postal_code}
                                      </b>
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Body className="text-center">
          <h2 className="logouticon"><ExclamationCircle /></h2>
          <h3 className="logout-text">
            {detail_info?.company === 1 ? (
              "Are you sure you want to update Company profile?"
            ) : (
              <>
                Are you sure you want to enroll as{" "}
                <b>
                  {pendingRoleData?.user_type === "1"
                    ? "Manufacturer"
                    : pendingRoleData?.user_type === "2"
                      ? "Agency"
                      : pendingRoleData?.user_type === "3"
                        ? "Dealers"
                        : "Company"}
                </b>
                ?
              </>
            )}
          </h3>
        </Modal.Body>
        <Modal.Footer className="logout text-center d-block gap-3 border-0">
          <button type="button" className="btn btn-secondary" onClick={handleConfirmEnrollment}>Yes</button>
          <button type="button" className="btn btn-primary" onClick={() => setShowConfirmModal(false)}>No</button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteDesignModal} onHide={() => setShowDeleteDesignModal(false)} centered>
        <Modal.Body className="text-center">
          <h2 className="logouticon text-danger"><ExclamationCircle /></h2>
          <h3 className="logout-text">Do you want to remove the design?</h3>
        </Modal.Body>
        <Modal.Footer className="logout text-center d-block gap-3 border-0">
          <button type="button" className="btn btn-secondary" onClick={handleConfirmDeleteDesign}>Yes</button>
          <button type="button" className="btn btn-primary" onClick={() => setShowDeleteDesignModal(false)}>No</button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Profile;
